import React, { Component } from 'react';
import Modal from 'react-modal';
import { inject, observer } from 'mobx-react';
import { message, Icon } from 'antd';


Modal.setAppElement('#root')

@inject("web3Store")
@inject("contractStore")
@inject("ViewStore")
class LoadingModal extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };

    }

    render() {

        

        return (
            <div className="login-modal-container">
            <div className="loading-v-logo-circle">
                  <img className="loading-v-logo" src={require('../../assets/img/logoV.svg')} />
                </div>
        </div>
        );
    }
}

export default LoadingModal;


// WEBPACK FOOTER //
// ./src/components/modals/LoadingModal.js